import React from 'react';
import i18n from 'utils/i18n';

// loading the sass style fot the component
import css from './styles.module.scss';
import { Button, Loader, Popup } from 'semantic-ui-react';
import { createFakeEvent } from '@/utils/functions';

const DEFAULT_COLOR = 'transparent';

const AVAIL_COLORS = [
  'white',
  'red',
  'orange',
  'yellow',
  'olive',
  'green',
  'teal',
  'blue',
  'violet',
  'purple',
  'pink',
  'brown',
  'grey',
  'black',
];

/**
 * Molecule ColorPicker
 * 
 * A regular color picker
 */
function ColorPicker (props) {
  // const gt = i18n.useTranslations('global');
  const t = i18n.useTranslations('components.color-picker');
  const leftHandle = React.useRef(null);
  const rightHandle = React.useRef(null);

  const [focused, setFocused] = React.useState(null);

  const {
    className = "",
    children,
    label = '',
    required,
    multiple,
    value = DEFAULT_COLOR,
    labelLeft,
    labelRight,
    inverted,
    name,
    onChange = _ => {},
    loading = false,
    duo,
    basic,
    readOnly = false,
    ...other
  } = props;

  const isDuo = duo || multiple || Array.isArray(value);
  const left = {
    label: labelLeft || value?.[0] || '',
    value: isDuo ? value?.[0] : value
  };
  const right = {
    label: labelRight || (isDuo ? value?.[1] : value),
    value: isDuo ? value?.[1] : value
  };

  function onColorChange (ev) {
    const localValue = ev.target.value;
    let event = {...ev};
    let target = { name, value: localValue };
    event.target = target;

    if (isDuo) {
      const name = ev.target.name; // 0 or 1
      const newValue = [...value];
      newValue[name] = localValue;

      target.value = newValue;
    }

    onChange(event, target);
    ev.stopPropagation();
    ev.preventDefault();
  }

  return <div
    className={`field ${className}`}
    // data-inverted={inverted ? 1 : null}
  >
    <label>{label}{required ? "*" : ""}</label>
    <div
      className={`${css["molecule__color-picker-container"]}`}
      data-focused={focused}
      data-duo={isDuo ? 1 : null}
      data-inverted={inverted ? 1 : null}
      {...other}
    >
      { isDuo && (
        <div // eslint-disable-line
          className={css['left-label']}
          title={left.value}
          onClick={_ => {
            if (readOnly) return;
            leftHandle.current.click();
          }}
        >
          {
            !basic && left.label
          }
        </div>
      )}
      <div className={css['color-preview']}>
        {
          <Loader
            active={!!loading}
            inline
            inverted
            style={{filter: 'drop-shadow(0 0 1px black)'}}
          />
        }

        <ColorPopup
          name={'0'}
          value={isDuo ? value?.[0] : value}
          readOnly={readOnly}
          onChange={onColorChange}
          onOpenPicker={event => {
            if (readOnly) return;
            leftHandle.current.click();
          }}
        />
        <ColorPopup
          name={'1'}
          value={isDuo ? value?.[1] : value}
          readOnly={readOnly}
          onChange={onColorChange}
          onOpenPicker={event => {
            if (readOnly) return;
            rightHandle?.current?.click();
          }}
        />
      </div>
      <div // eslint-disable-line
        className={css['right-label']}
        onClick={_ => {
          if (readOnly) return;
          const handler = isDuo ? rightHandle : leftHandle;
          handler?.current?.click();
        }}
      >
        {
          !basic && right.label
        }
      </div>

      <input
        type={loading ? 'text' : 'color'}
        name={'0'}
        onFocus={_ => {
          setFocused(isDuo ? 'a' : 'full');
        }}
        onBlur={_ => {
          setFocused(null);
        }}
        readOnly={readOnly}
        className={css['real-input']}
        ref={leftHandle}
        label={t(isDuo ? 'selectLeft' : 'select')}
        title={t(isDuo ? 'selectLeft' : 'select')}
        value={isDuo ? value?.[0] : value}
        defaultValue={(isDuo ? value?.[0] : value) || DEFAULT_COLOR}
        onChange={onColorChange}
        // onInput={_ => {
        //   console.log('inputed');
        // }}
      />
      {
        isDuo && (
          <input
            type={loading ? 'text' : 'color'}
            name={'1'}
            className={css['real-input']}
            onFocus={_ => {
              setFocused('b');
            }}
            onBlur={_ => {
              setFocused(null);
            }}
            readOnly={readOnly}
            ref={rightHandle}
            label={t('selectRight')}
            title={t('selectRight')}
            value={value?.[1] || DEFAULT_COLOR}
            onChange={onColorChange}
          />
        )
      }
    </div>
    {children}
  </div>;
}

export default ColorPicker;

function ColorPopup (props) {

  const {
    readOnly,
    onOpenPicker,
    value,
    name,
    onChange,
  } = props;

  return (
    <Popup
      position='top center'
      disabled={readOnly}
      content={<div className={css['color-options-container']}>
        <div>
          <div className={'no-wrap'}>
            {
              AVAIL_COLORS.slice(0, 7).map((color, i) => {
                return (
                  <Button
                    key={color}
                    /* eslint-disable */
                    autoFocus={i === 0}
                    /* eslint-enable */
                    size='small'
                    type="button"
                    color={color}
                    onClick={_ => {
                      onChange(createFakeEvent(name, color));
                    }}
                  />
                );
              })
            }
          </div>
          <div className={'no-wrap'}>
            {
              AVAIL_COLORS.slice(7).map(color => {
                return (
                  <Button
                    key={color}
                    size='small'
                    color={color}
                    onClick={_ => {
                      onChange(createFakeEvent(name, color));
                    }}
                  />
                );
              })
            }
          </div>
        </div>
        <Button
          circular
          icon="tint"
          basic
          onClick={onOpenPicker}
        />
        <Button
          circular
          // icon="eye slash outline"
          icon="dont"
          basic
          onClick={_ => {
            onChange(createFakeEvent(name, 'transparent'));
          }}
        />
      </div>}
      on='click'
      trigger={<div
        className={css['color-' + (name === '1' ? 'a' : 'b')]}
        style={{background: value}}
        title={value}
        // onClick={_ => {
        //   if (readOnly) return;
        //   const handler = isDuo ? rightHandle : leftHandle;
        //   handler.current.click();
        // }}
      />}
    />
  );
}
